import { render } from "./App.vue?vue&type=template&id=875651b8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=875651b8&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/rlb-poc.prepare.servicedesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__